@if (showGenerateReport) {
  <div>
    @if ((reportGenerationInProgress | async) && !oldReport) {
      <mat-icon
        class="reportPendingIcon icon-white"
        [ngClass]="isEditButton ? 'mr-5' : 'mr-2'"
        matTooltip="Report request is being processed, please do not leave this page."
        matTooltipPosition="before"
        matTooltipClass="quartz-tooltip"
        >av_timer
      </mat-icon>
    }
    @if (!isEditButton) {
      <button mat-raised-button color="primary" [disabled]="((reportGenerationInProgress | async) && !oldReport) || !enableReportGeneration" (click)="onGenerateReportClicked()">
        Generate Report
      </button>
    }
    @if (isEditButton) {
      <button mat-mini-fab color="primary"
        [disabled]="((reportGenerationInProgress | async) && !oldReport) || !enableReportGeneration"
        class="create-report-btn icon-white"
        (click)="onGenerateReportClicked()">
        <mat-icon class="icon-white">create</mat-icon>
      </button>
    }
  </div>
}
<app-in-progress [loading]="loadingData && oldReport"></app-in-progress>
